import React from "react";

type LoaderProps = {
  text?: string;
  size?: "sm" | "md";
  fullScreen?: boolean;
};

const Loader = ({ text = "Loading", size = "md", fullScreen = false }: LoaderProps) => {
  const spinnerSize = size === "sm" ? "h-4 w-4 border-2" : "h-8 w-8 border-4";
  const wrapperClass = fullScreen
    ? "min-h-screen flex items-center justify-center"
    : "flex items-center justify-center";

  return (
    <div className={wrapperClass}>
      <div className="flex items-center gap-3 text-gray-600">
        <div
          className={`${spinnerSize} border-blue-600 border-t-transparent rounded-full animate-spin`}
          aria-hidden="true"
        />
        <span className={size === "sm" ? "text-sm" : "text-base"}>{text}</span>
      </div>
    </div>
  );
};

export default Loader;
